module.exports = __webpack_public_path__ + "static/ccmi-fc20246079ce5f5b32278a22055efa00.png";